function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19 3.75H5C4.30964 3.75 3.75 4.30964 3.75 5V19C3.75 19.6904 4.30964 20.25 5 20.25H19C19.6904 20.25 20.25 19.6904 20.25 19V5C20.25 4.30964 19.6904 3.75 19 3.75Z",
  stroke: "currentColor",
  strokeWidth: 1.5
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 11H7.5C7.22386 11 7 11.2239 7 11.5V12.5C7 12.7761 7.22386 13 7.5 13H8.5C8.77614 13 9 12.7761 9 12.5V11.5C9 11.2239 8.77614 11 8.5 11Z",
  fill: "currentColor"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 15H7.5C7.22386 15 7 15.2239 7 15.5V16.5C7 16.7761 7.22386 17 7.5 17H8.5C8.77614 17 9 16.7761 9 16.5V15.5C9 15.2239 8.77614 15 8.5 15Z",
  fill: "currentColor"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 7H7.5C7.22386 7 7 7.22386 7 7.5V8.5C7 8.77614 7.22386 9 7.5 9H16.5C16.7761 9 17 8.77614 17 8.5V7.5C17 7.22386 16.7761 7 16.5 7Z",
  fill: "currentColor"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 11H10.5C10.2239 11 10 11.2239 10 11.5V12.5C10 12.7761 10.2239 13 10.5 13H16.5C16.7761 13 17 12.7761 17 12.5V11.5C17 11.2239 16.7761 11 16.5 11Z",
  fill: "currentColor"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 15H10.5C10.2239 15 10 15.2239 10 15.5V16.5C10 16.7761 10.2239 17 10.5 17H16.5C16.7761 17 17 16.7761 17 16.5V15.5C17 15.2239 16.7761 15 16.5 15Z",
  fill: "currentColor"
});
function SvgText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.00b808fa.svg";
export { ForwardRef as ReactComponent };